import React from 'react';
import {twMerge} from 'tailwind-merge';

function buildGradientStops(colors: readonly string[]): string {
  if (colors.length === 0) {
    return 'transparent, transparent';
  }

  if (colors.length === 1) {
    return `${colors[0]}, ${colors[0]}`;
  }

  return colors
    .map((color, index) => {
      const position = (index / (colors.length - 1)) * 100;
      return `${color} ${position}%`;
    })
    .join(', ');
}

export const ColorPaletteGradient = ({
  colors,
  className,
}: {
  colors: readonly string[];
  className?: string;
}) => {
  const gradientStops = buildGradientStops(colors);

  return (
    <div
      style={{'--tw-gradient-stops': gradientStops} as React.CSSProperties}
      className={twMerge('h-12 w-full rounded-lg bg-gradient-to-r', className)}
    />
  );
};
